(ns app.domain.application.guards.utils
  (:require #?(:clj [core.authorization.core :as auth])
            [app.domain.group.model :as group-model]
            [app.domain.util :as du]
            [core.permission.resolver :as permission-resolver]))

(defn get-param [fsm key]
  (-> fsm :tilakone.core/signal second key))

(defn find-child-entity [fsm entity-key]
  (let [entity-id (get-param fsm entity-key)
        target    (-> fsm :request :target)]
    (when entity-id
      (du/find-descendant {:db/id entity-id} target))))

(defn get-authority-group [fsm]
  (-> fsm
      :request
      :target
      group-model/get-authority-group))

(defn get-domain-group [fsm]
  (-> fsm
      get-authority-group
      :entity/parent))

(defn group-feature-available? [fsm feature]
  (-> fsm
      get-authority-group
      (group-model/has-feature? feature)))

(defn domain-group-feature-available? [fsm feature]
  (-> fsm
      get-domain-group
      (group-model/has-feature? feature)))

(defn integration-available? [fsm]
  (group-feature-available? fsm :group.feature/backend-system-integration))


(defn fee-integration-available? [fsm]
  (and (integration-available? fsm)
       (group-feature-available? fsm :group.feature/fee-integration)))


(defn generate-bill-pdf-available? [fsm]
  (group-feature-available? fsm :group.feature/generate-bill-pdf))

(defn has-permission?
  "Does the user have the given permission to the target workspace?"
  [{{{workspace :entity/parent} :target} :request
    user                                 :core.user/user}
   permission]
  (let [permissions (permission-resolver/permissions workspace user)]
    (contains? permissions permission)))

(defn user-is-admin? [user]
  #?(:clj  (auth/cached-admin? user)
     :cljs (-> user :user/admin-permissions :permission/admin boolean)))
